function OnsiteVisitsView() {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visits: "=",
            reports: "=",
            filterReport: "="
        },
		template: require('./visits-view.html'),

        link: function (scope) {

        }
    }
}

angular.module('onsite').directive('onsiteVisitsView', [OnsiteVisitsView]);
